import {NgModule} from '@angular/core';

// Modules
import {BrowserModule} from '@angular/platform-browser';
import {TranslateModule} from 'ng2-translate';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {RouterModule} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';

// Services
import {AppService} from './services/app-service';
import {TranslateService} from './services/translate-service';
import {NavigationService} from './services/navigation-service';
import {AnimateService} from './services/animate-service';
import {LogsService} from './services/logs-service';
import {UtilsService} from './services/utils-service';

// Components
import {NotFound404PageCmp} from './pages/not-found-404-page.cmp';
import {NavigationMenuCmp} from './components/layout/navigation-menu.cmp';
import {QuickMenuCmp} from './components/layout/quick-menu.cmp';
import {StartArrowCmp} from './components/layout/start-arrow.cmp';
import {ModalCmp} from './components/ui-elements/modal.cmp';
import {AlertCmp} from './components/alert/alert.cmp';

import {OptionsMenuCmp} from './components/layout/options-menu.cmp';
import {ProductCategoriesListCmp} from '../catalog/shared/components/product-categories/product-categories-list.cmp';
import {ProductsTinyListCmp} from '../catalog/shared/components/products/products-tiny-list.cmp';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SharedModule'));

/**
 * Shared module contains all the stuff necessary all over the app
 */
@NgModule({
    imports: [
        BrowserModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        RouterModule
    ],
    providers: [
        AppService,
        TranslateService,
        NavigationService,
        AnimateService,
        LogsService,
        UtilsService
    ],
    declarations: [
        NotFound404PageCmp,
        NavigationMenuCmp,
        QuickMenuCmp,
        StartArrowCmp,
        ModalCmp,
        AlertCmp,
        OptionsMenuCmp,
        ProductCategoriesListCmp, // Decouple
        ProductsTinyListCmp // Decouple
    ],
    exports: [
        TranslateModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        RouterModule,
        NavigationMenuCmp,
        QuickMenuCmp,
        ModalCmp,
        AlertCmp,
        OptionsMenuCmp,
    ]
})
export class SharedModule {
    constructor () {
        // 'Construct shared module' );
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/shared-module.ts